@if (repraesentation.teilnahmen.length > 0) {
  <div class="col-xs-12 mt-4">
    <table class="table table-condensed borderless mb-0">
      <thead>
        <tr>
          <th colspan="1">Teilnahmen</th>
          <th colspan="1">Standplatz</th>
        </tr>
      </thead>
      <tbody>
      @for (teilnahme of repraesentation.teilnahmen | slice:0:maxNoOfFruehereTeilnahmenToShow; track teilnahme) {
        <tr>
          <td>
            <a routerLink="/veranstaltungen/{{teilnahme.veranstaltung.id}}/anmeldungen">{{teilnahme.veranstaltung?.name}}</a>
          </td>
          <td>
            @if (teilnahme.standplatz) {
              <a style="cursor: pointer"
              (click)="navigateToStandplatz(teilnahme)">{{teilnahme.standplatz.fullDescription}}</a>
            }
            @if (!teilnahme.standplatz) {
              <span style="padding-right: 1.5em;">&ndash;</span>
            }
          </td>
        </tr>
      }
      @if (repraesentation.teilnahmen.length > maxNoOfFruehereTeilnahmenToShow) {
        <tr>
          <td colspan="2"><a
            (click)="maxNoOfFruehereTeilnahmenToShow = repraesentation.teilnahmen.length"
          style="cursor: pointer">Mehr anzeigen...</a></td>
        </tr>
      }
      @if (repraesentation.teilnahmen.length === 0) {
        <tr>
          <td class="text-muted">Keine Teilnahmen</td>
        </tr>
      }
      </tbody>
    </table>
  </div>
}